import React, { useState } from 'react'
import Select from 'react-select'
import { useDispatch, useStore } from 'react-redux'
import { Modal } from 'rsuite'
import { toast } from '../../CommonComponents/ToastComponent/toast'
import LoaderComponent from '../../CommonComponents/LoaderComponent'
import { useHistory, useLocation } from 'react-router-dom'
import { doInviteUserToDomain } from '../../../redux/actions/domain'
import { doLogOut, doSignup, doSignupStart } from '../../../redux/actions/auth'



const DomainSignupModal = ({ show, onClose, userEmail }) => {
  const str = userEmail.substr(0, userEmail.indexOf("@"))
  const pswd = "password"
  const [email, setEmail] = useState(userEmail)
  const [password, setPassword] = useState('')
  const [firstName, setFirstName] = useState(str)
  const [lastName, setLastName] = useState(str)
  const [userName, setUserName] = useState('directInvite')

  const store = useStore().getState()
  const dispatch = useDispatch()

  const history = useHistory()
  const location = useLocation()

  const onSignupDirect = () => {
    // dispatch(doSignup({
    //   email,
    //   password,
    //   firstName,
    //   lastName,
    //   userName
    // })).then(() => {
    //   toast.show({
    //     title: 'Success',
    //     description: 'Created an account successfully!',
    //   })
    //   return
    // })

    dispatch(doSignup({
      email: userEmail,
      password: pswd,
      firstName: str,
      lastName: str,
      userName
    })).then(() => {
      toast.show({
        title: 'Success',
        description: 'Created an account successfully!',
      })
      onClose()
    })


  }

  const {
    domain: { isLoading },
  } = store

  return (
    <Modal
      backdrop={true}
      className="domain-invite-modal"
      show={show}
      size="xs"
      onClick={onClose}
      onHide={onClose}
    >
      <Modal.Header>
        <Modal.Title>
          To invite, please enter user information.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={`invite-domain ${isLoading ? 'loading' : ''}`}>
          {isLoading && <LoaderComponent />}
          <div className="content">
            <div className="list">
              <div className='item'>
                <input type="text" placeholder="First Name" disabled value={str} onChange={(e) => setFirstName(e.target.value)} />
              </div>
            </div>
            <div className="list">
              <div className='item'>
                <input type="text" placeholder="Last Name" disabled value={str} onChange={(e) => setLastName(e.target.value)} />
              </div>
            </div>
            <div className="list">
              <div className='item'>
                <input type="text" placeholder="Email Address" disabled value={userEmail} onChange={(e) => setEmail(e.target.value)} />
              </div>
            </div>
            <div className="list">
              <div className='item'>
                <input type="password" placeholder="Password" disabled value="password" onChange={(e) => setPassword(e.target.value)} />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="action-container">
          <button type="button" disabled={isLoading} className="btn btn-black" onClick={onSignupDirect}>
            Invite
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default DomainSignupModal